export default __webpack_public_path__ + "static/media/team88.f6c9bd77.JPG";